module.exports = require("core-js-pure/features/date/now");